let resizeTimeout: NodeJS.Timeout | null = null;
const imageHandlers: Array<{ img: HTMLImageElement; handler: () => void }> = [];

function calculateAshMaterialsHeight() {
    const items = document.querySelectorAll<HTMLElement>('.ash-materials__item');
    const list = document.querySelector<HTMLElement>('.ash-materials__list');
    const left = document.querySelector<HTMLElement>('.ash-materials__left');

    if (!items.length || !list || !left) {
        return;
    }

    const firstItem = items[0] as HTMLElement;
    const fourthItem = items[3] as HTMLElement;
    const itemHeight = firstItem.offsetHeight;
    const itemFourthHeight = fourthItem ? fourthItem.offsetHeight : 0;

    const listStyles = window.getComputedStyle(list);
    const gap = parseInt(listStyles.gap, 10) || 10;

    left.style.setProperty('--ash-item-height', `${itemHeight + itemFourthHeight}px`);
    left.style.setProperty('--ash-item-gap', `${gap}px`);
}

function handleResize() {
    if (resizeTimeout) {
        clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(calculateAshMaterialsHeight, 100);
}

function init(container: Element | Document = document) {
    calculateAshMaterialsHeight();

    window.addEventListener('resize', handleResize);

    const images = Array.from(container.querySelectorAll<HTMLImageElement>('.ash-materials__item img'));
    images.forEach((img) => {
        const handler = () => calculateAshMaterialsHeight();
        img.addEventListener('load', handler);
        imageHandlers.push({ img, handler });
    });
}

function destroy() {
    if (resizeTimeout) {
        clearTimeout(resizeTimeout);
        resizeTimeout = null;
    }

    window.removeEventListener('resize', handleResize);

    imageHandlers.forEach(({ img, handler }) => {
        img.removeEventListener('load', handler);
    });
    imageHandlers.length = 0;
}

const _module = { init, destroy };

export default _module;
